<template>
	<div>
		<pageHead></pageHead>
		<div class="service-main">
			<page-banner :title="'服务内容'" :breadTxt="'应急响应'" :tipTxt="'提供“规范、科学、公正、专业、诚信”的等级保护测评服务'"></page-banner>
			
			<p class="t-align-center serviceT mt-50">应急响应</p>
			<p class="t-align-center serviceT mt-10 mb-20">Emergency response</p>
			<div class="m-0auto maxw-1400">
				<p class="t-indent2 line-26 fz-18 pb-20">在服务期间，因发生网络安全事件，客户可以获得网络安全应急响应服务。本公司设有7x24小时的热线电话服务，由专门的客户服务代表受理用户来电，保证用户及时得到技术上的支援。</p>
				<img src="../../assets/img/service/u31.png" class="pb-50" alt="">
			</div>
		</div>
		
		<page-foot></page-foot>
	</div>
</template>

<script>
	import pageHead from '../../components/pageHead'
	import pageBanner from '../../components/pageBanner'
	import pageFoot from '../../components/pagefoot'
	export default{
		components:{
			pageHead,
			pageBanner,
			pageFoot
		},
		data(){
			return {
				
			}
		},
		methods:{
			
		}
	}
</script>

<style scoped>
.proBox{
	width: 100%;
	max-width: 1400px;
	height: auto;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	margin: 20px auto;
	border-radius: 15px;
}
.serviceT{
	font-size: 24px;
	font-weight: 800;
}
img{
	width: 100%;
}
</style>